import { render, staticRenderFns } from "./PopupTasksList.vue?vue&type=template&id=710aa604"
import script from "./PopupTasksList.vue?vue&type=script&lang=ts"
export * from "./PopupTasksList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports